/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Status_DeliveredInputs */

const en_project_status_delivered = /** @type {(inputs: Project_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivered project`)
};

const lv_project_status_delivered = /** @type {(inputs: Project_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izveidots darbs`)
};

/**
* | output |
* | --- |
* | "Delivered project" |
*
* @param {Project_Status_DeliveredInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_status_delivered = /** @type {((inputs?: Project_Status_DeliveredInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Status_DeliveredInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_status_delivered(inputs)
	return en_project_status_delivered(inputs)
});